export const type = 'clickMensajes';

const clickMensajes = (text) => ({
    type,
    payload: new Date(),
    accion:text
});

export default clickMensajes;